export const sharedRoutes = {
  ssoCallback: '/sso/callback',
};
